/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot re-loadable.
 */

import SampleModuleReducers from './SampleModule/reducers';

import VerificationsReducers from './Verifications/reducers';

import ExternalUserInformationReducers from './ExternalUserInformation/reducers';

import SDApplicationReducers from './SDApplication/reducers';

import UserCOCReducers from './UserCOC/reducers';

import UserRenewalsReducers from './UserRenewals/reducers';

import SurveyReducers from './Survey/reducers';

import OnlineCategoriesReducers from './OnlineCategories/reducers';

import SDCodeTableServiceReducers from './SDCodeTableService/reducers';

import ExternalUserLinkAccountReducers from './ExternalUserLinkAccount/reducers';

import SDYourSettingsReducers from './SDYourSettings/reducers';

import SDUserCoverageInformationReducers from './SDUserCoverageInformation/reducers';

import RIDPReducers from './RIDP/reducers';

import ExternalUserAccessTokenReducers from './ExternalUserAccessToken/reducers';

import SDSignupReducers from './SDSignup/reducers';

import DocumentServiceReducers from './DocumentService/reducers';

import SDFilesReducers from './SDFiles/reducers';

import SDApplicationFormReducers from './SDApplicationForm/reducers';

import SDCCAPaymentsReducers from './SDCCAPayments/reducers';

/**
 * Creates the main reducer which combines all the reducers from the modules
 * and any provided reducers supplied from the wrapping application.
 *
 * Provided reducers are ignored where there is a clash in naming.
 *
 * @namespace UAReduxReducers
 */
export default {
  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASampleModule: SampleModuleReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAVerifications: VerificationsReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAExternalUserInformation: ExternalUserInformationReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASDApplication: SDApplicationReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAUserCOC: UserCOCReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAUserRenewals: UserRenewalsReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASurvey: SurveyReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAOnlineCategories: OnlineCategoriesReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASDCodeTableService: SDCodeTableServiceReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAExternalUserLinkAccount: ExternalUserLinkAccountReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASDYourSettings: SDYourSettingsReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASDUserCoverageInformation: SDUserCoverageInformationReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UARIDP: RIDPReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UAExternalUserAccessToken: ExternalUserAccessTokenReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASDSignup: SDSignupReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UADocumentService: DocumentServiceReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASDFiles: SDFilesReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASDApplicationForm: SDApplicationFormReducers.reducers,

  /**
   * Holds the application configuration state within the store.
   * @memberof UAReduxReducers
   * @property
   */
  UASDCCAPayments: SDCCAPaymentsReducers.reducers,
};
